export const taxInformationTranslationObject = {
  taxInformation: {
    'REGISTER.TAX_INFORMATION.HEADER': 'Additional Information',
    'PROFILE.TAX_INFORMATION.HEADER': 'Tax Information',
    'PROFILE.TAX_INFORMATION.VAT': 'Are you VAT registered?',
    'PROFILE.TAX_INFORMATION.VAT_NUMBER': 'VAT Number:',
    'PROFILE.TAX_INFORMATION.LLC': 'Are you working via a limited company?',
    'PROFILE.TAX_INFORMATION.LLC_NAME': 'Company Name:',
    'PROFILE.TAX_INFORMATION.LLC_NUMBER': 'Company Number:',
    'PROFILE.TAX_INFORMATION.RECEIVE_VAT':
      'Do you want to receive VAT for your services?',
    'REGISTER.DETAILS.MESSAGE.VALID': 'all * fields are required',
    'GENERIC.NEXT': 'Next',
    'GENERIC.BACK': 'Back',
    'GENERIC.SUBMIT': 'Submit',
    'GENERIC.YES': 'Yes',
    'GENERIC.NO': 'No',
    'PROFILE.TAX_INFORMATION.VAT_ERROR':
      'The VAT number seems incorrect. The VAT for {0} should look like this {1}',
  },
};
